var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-tavolo-mobile" },
    [
      _c(
        "v-main",
        [
          _c(
            "v-dialog",
            {
              attrs: {
                eager: "",
                "max-width": "450",
                "content-class": "asta-svincolati-mobile-dialog",
              },
              model: {
                value: _vm.svincolatiDrawer,
                callback: function ($$v) {
                  _vm.svincolatiDrawer = $$v
                },
                expression: "svincolatiDrawer",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "secondary white--text" },
                    [
                      _c("span", { staticClass: "font-hemi-head" }, [
                        _vm._v("SVINCOLATI"),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.toggleSvincolati },
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("close"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("asta-svincolati", { staticClass: "navy" }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "asta-tavolo-mobile" },
            [_c("asta-tavolo")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "asta-chat-messages-mobile" },
            [_c("asta-chat-messages")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "asta-chat-input-mobile" },
            [_c("asta-chat-input")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "floating-buttons-mobile" },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "gradient-green", rounded: "", large: "" },
                  on: { click: _vm.toggleSvincolati },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "floating-button-content d-flex flex-column justify-center align-center white--text",
                    },
                    [
                      _c("v-icon", [_vm._v("groups ")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "font-hemi-head floating-button-label" },
                        [_vm._v("Svincolati")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "gradient-green", rounded: "", large: "" },
                  on: { click: _vm.showDialogPlan },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "floating-button-content d-flex flex-column justify-center align-center white--text",
                    },
                    [
                      _c("v-icon", [_vm._v("paid")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "font-hemi-head floating-button-label" },
                        [_vm._v("\n            Pianificazione\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "gradient-green", rounded: "", large: "" },
                  on: { click: _vm.showDialogRoseLega },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "floating-button-content d-flex flex-column justify-center align-center white--text",
                    },
                    [
                      _c("v-icon", [_vm._v("view_column")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "font-hemi-head floating-button-label" },
                        [_vm._v("Rose lega")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }